import { cn } from "@resume-studio/utils";
import * as React from "react";

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
  icon?: React.ComponentType<{ className?: string }>;
  className?: string;
}

/**
 * Spec:
 *
 * - Single Lucide glyph at `size-5 text-subtle` — no illustrations,
 *   no oversized icons.
 * - 14px copy.
 * - Ghost / muted background, no dashed border (Stripe never uses dashed
 *   inside the chrome — looks like a wireframe placeholder).
 */
export const EmptyState = ({
  title,
  description,
  action,
  icon: Icon,
  className,
}: EmptyStateProps) => (
  <div
    className={cn(
      "flex flex-col items-center justify-center rounded-md border border-border bg-surface px-6 py-12 text-center",
      className,
    )}
  >
    {Icon && <Icon className="mb-3 size-5 text-subtle" />}
    <h3 className="text-[14px] font-semibold text-foreground">{title}</h3>
    {description && (
      <p className="mt-1 max-w-sm text-[13px] text-muted-foreground">{description}</p>
    )}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
